import { useTranslation } from 'react-i18next';
import { cx } from '@platform/core/lib/cx';
import type { IChipProps } from './IChipProps';

/** Чип (UIUX/controls/tag-input): 26px, радіус 13px, крапка кольору 8px; з onRemove — кнопка «×» (символ, як у прототипі) для вилучення (теги). */
export function Chip({ children, color, onRemove, className, title }: IChipProps) {
  const { t } = useTranslation();
  return (
    <span className={cx('chip', onRemove && 'chip--removable', className)} title={title}>
      {color && <span className="chip__dot" style={{ background: color }} />}
      <span className="chip__text">{children}</span>
      {onRemove && (
        <button type="button" className="chip__x" aria-label={t('ui.remove')} title={t('ui.remove')} onClick={onRemove}>
          ×
        </button>
      )}
    </span>
  );
}
